import { useTranslation } from "react-i18next";

import { useLazyGetLegalNoticeQuery } from "../../app/api/public";
import { AppendicesDialog } from "./AppendicesDialog";

export const LegalNoticeDialog = () => {
  const [getText, getTextApiState] = useLazyGetLegalNoticeQuery();

  const { t } = useTranslation();
  const { messages, title, trigger } = t(
    "appendices.LegalNoticeDialog",
  ) as unknown as {
    messages: { error: { unknown: string } };
    title: string;
    trigger: string;
  };

  return (
    <AppendicesDialog
      apiState={getTextApiState}
      dataLayer={{
        page: {
          category_page: "mentions_legales",
          nom_page: "Mentions légales",
        },
        trigger: {
          eventAction: "clic_footer",
          eventCategory: "footer",
          eventLabel: "mentions_légales",
        },
      }}
      messages={messages}
      title={title}
      trigger={trigger}
      onOpenChange={() => getText(undefined, true)}
    />
  );
};
